import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import toastr from "toastr";
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiTrash2, FiEdit3, FiImage, FiEye } from "react-icons/fi";
import { FaHistory } from "react-icons/fa";
import { customColumnMatch } from "app/_helpers/helper";
import {
  getUserAccessRoles,
  getUserRolePermission,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";

import { IoIosUndo } from "react-icons/io";
import {
  FaRegFileExcel,
  FaRegFileWord,
  FaRegTrashAlt,
  FaPen,
  FaEye,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { SupportService } from "app/_services/Support/supportService";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { calaculateYearsDifferenceForPastDate, mdyDateFormat } from "app/_helpers/helper";
import { connect } from "react-redux";
import TableExport from "app/views/custom/components/Export/TableExport";
import LastLog from "app/views/custom/components/Logs/LastLog";
import { date } from "yup";
import { CommmonService } from "app/_services/CommonService/CommonService";

import { UserService } from "app/_services/UserService/UserService";
import moment from "moment";

class Support extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    userData: "",
    superadmin: "",
    casingTypeData: [],
    projectData: {},
    projectId: this.props.match.params.id ? this.props.match.params.id : null,
  };

  defaultSorted = [
    {
      dataField: "name",
      order: "asc",
    },
  ];

  componentDidMount() {
    this.loggedUser();
    this.setCasingTypeData();
    this.setProjectDetails();
  }
  async loggedUser() {
    let response = await UserService.loggedUser();
    if (response && response.status) {
      this.setState({
        userData: response?.data?.id,
      });
    }
    this.checkuser(this.state.userData);
    console.log("PermissionsAre", this.props.user.role.roleLable);
  }

  async checkuser(data) {
    if (this.state.userData != "") {
      const response = await CommmonService.userCheck(data);
      //   if (!response?.status) return toastr.error(response?.message);
      console.log(response);
      this.setState({
        superadmin: response,
      });
      // console.log("here>", this.state.superadmin);
    }
  }

  async setProjectDetails() {
    let response = await ProjectService.projectDetailsByID(this.state.projectId);

    if (response && response.status) {
      if (response.data && response.data) {
        this.setState({
          projectData: response.data,
        });
      }
    }
  }

  async setCasingTypeData() {
    let response;
    // if (this.props.user.role.roleLable === 6) {
    response = await SupportService.getSupport();
    // if (this.props.user.role.roleLable !== 1) {
    //   response.data = response.data?.filter((d) => {
    //     if (d.ticketStatus === "reassigned") {
    //       if (
    //         d.assignedTo !== this.props.user.user.id &&
    //         d.createdBy !== this.props.user.user.id
    //       )
    //         return false;
    //     }
    //     if (d.ticketStatus === "inProgress") {
    //       if (
    //         d.startedBy !== this.props.user.user.id &&
    //         d.createdBy !== this.props.user.user.id
    //       )
    //         return false;
    //     }
    // if (d.ticketStatus === "closed") {
    //   if (d.createdBy !== this.props.user.user.id) return false;
    // }
    //     return true;
    //   });
    // }

    // } else {

    if (response && response.status) {
      if (response.data) {
        if (
          this.props.user.role.roleLable !== 6 &&
          this.props.user.role.roleLable !== 1
        ) {
          response["data"] = response
            ? response?.data?.filter((d) => {
                return d.createdBy === this.props.user.user.id;
              })
            : [];
        }
        this.setState(
          {
            casingTypeData: response.data,
          },
          () => {
            let data = JSON.parse(JSON.stringify(this.state.casingTypeData));
            Array.isArray(data) &&
              data.map((rowData, rowindex) => {
                rowData["sid"] = rowindex + 1;
              });
            this.setState({
              casingTypeData: data,
            });
          }
        );
      }
    } else {
      this.setState({
        casingTypeData: [],
      });
    }
  }
  delete(e, projectId, id) {
    e.preventDefault();

    confirmAlert({
      title: "Delete Ticket",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await SupportService.deleteSupport(id);

            if (response && response.status) {
              toastr.info(response.message || "Deleted Successfully!");
              this.setCasingTypeData();
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }
  reopen(e, projectId, id) {
    e.preventDefault();

    confirmAlert({
      title: "Reopen Ticket",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await SupportService.reOpen(id);

            if (response && response.status) {
              toastr.info(response.message || "Ticket reopend");
              this.setCasingTypeData();
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }
  paginationOptions = {
    // custom: true,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: this.state.casingTypeData.length,
  };

  render() {
    console.log("state data", this.state);
    let { casingTypeData } = this.state;
    let { SearchBar } = Search;
    // console.log(calaculateYearsDifferenceForPastDate('2022-11-14 17:39:09'));
    let sortableColumn = [
      {
        dataField: "sid",
        text: "S.No.",
        // sort: true,
        formatter: (d, row, idx) => {
          return idx + 1;
        },
      },
      {
        dataField: "ticket_no",
        text: "Ticket No.",
        sort: true,
      },
      {
        dataField: "createdByUser.firstName",
        text: "Reported By",
        sort: true,
        formatter: (rowContent, row, index) => {
          if (row.createdByUser) {
            return row.createdByUser.firstName + " " + row.createdByUser.lastName;
          }
        },
      },
      {
        dataField: "createdAt",
        text: "Date Created",
        sort: true,
        formatter: (rowContent, row, index) => {
          return mdyDateFormat(row.createdAt);
        },
      },
      {
        dataField: "ticketStatus",
        text: "Status",
        sort: true,
        formatter: (rowContent, row, index) => {
          if (row.ticketStatus === "closed") return "Closed";
          if (row.ticketStatus === "reassigned") return "Re-Assigned";
          if (row.ticketStatus === "submitted") return "Submitted";
          if (row.ticketStatus === "inProgress") return "In Progress";
          if (row.ticketStatus === "reOpened") return "Re-Opened";
        },
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          console.log("rowsssssssssssssss", row);
          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <Link
                  to={"/support/ticket-view/" + row.id}
                  className="text-cyanBlue icons"
                >
                  <FiEye />
                </Link>
              </OverlayTrigger>
              {row.createdBy == this.props.user.user.id && (
                <React.Fragment>
                  {row.ticketStatus === "submitted" && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                    >
                      <Link
                        to={"/support/edit-ticket/" + row.id}
                        className="icons text-cyanBlue"
                      >
                        <FiEdit3 />
                      </Link>
                    </OverlayTrigger>
                  )}
                  {row.ticketStatus === "submitted" && (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Delete Ticket</Tooltip>}
                    >
                      <a
                        onClick={(e) => this.delete(e, row.projectId, row.id)}
                        href="#"
                        className="icons text-danger"
                      >
                        <FaRegTrashAlt />
                      </a>
                    </OverlayTrigger>
                  )}
                  {row.ticketStatus === "closed" &&
                  calaculateYearsDifferenceForPastDate(row.closedAt, "days") <= 7 ? (
                    //   &&
                    // this.state.superadmin == 1
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Reopen Ticket</Tooltip>}
                    >
                      <a
                        onClick={(e) => this.reopen(e, row.projectId, row.id)}
                        href="#"
                        className="icons text-danger"
                      >
                        <FaHistory />
                      </a>
                    </OverlayTrigger>
                  ) : (
                    <></>
                  )}
                </React.Fragment>
              )}
            </div>
          );
        },
      },
    ];
    let userPermissions = JSON.parse(localStorage.getItem("userPermissions"));

    if (userPermissions && userPermissions["superAdmin"]) {
      let obj = {
        dataField: "reportedByUser.firstName",
        text: "Reported By",
        sort: true,
        formatter: (rowContent, row, index) => {
          let reportedByUser = row.reportedByUser;
          let name = "";
          if (reportedByUser) {
            name =
              (reportedByUser.firstName ? reportedByUser.firstName : "") +
              " " +
              (reportedByUser.lastName ? reportedByUser.lastName : "");
          }
          return name;
        },
      };
      sortableColumn.splice(6, 0, obj);
    }

    const table = (
      <ToolkitProvider
        striped
        keyField="id"
        data={casingTypeData?.map((d, idx) => ({ ...d, sid: idx + 1 }))}
        columns={sortableColumn}
        // search
        search={{
          onColumnMatch: customColumnMatch,
          searchFormatted: true,
          defaultSearch: "",
        }}
      >
        {(props) => (
          <>
            <div className="d-flex align-items-center justify-content-between pb-3">
              <SearchBar {...props.searchProps} className="mb-0" />
              <div className="btn-toolbar">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Add Ticket</Tooltip>}
                >
                  <Link
                    className="icons btn-icon font-20 text-cyanBlue"
                    to={"/support/create-ticket"}
                  >
                    <FiPlusCircle />
                  </Link>
                </OverlayTrigger>

                <TableExport
                  tableName={"Support"}
                  dataColumn={sortableColumn}
                  renderData={casingTypeData}
                  searchText={props.searchProps.searchText}
                  hideExportWord
                ></TableExport>
              </div>
            </div>
            <BootstrapTable
              {...props.baseProps}
              bootstrap4
              pagination={paginationFactory(this.paginationOptions)}
              noDataIndication={"Table is empty"}
            />
          </>
        )}
      </ToolkitProvider>
    );

    return (
      <div>
        <MainBreadcrumb
          routeSegments={[{ name: "Support", path: "#" }]}
          breadCrumbsText="Support"
        />
        <div className="card p-4 mb-4">
          {this.state.superadmin ? table : <div>{table}</div>}
        </div>
        <LastLog subModulename={"support"}></LastLog>
      </div>
    );
  }
}

// export default TicketView
const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Support);
